import { useState } from 'react';
import { api, errMsg } from '@/lib/api';
import { Panel, Tag } from '@/components/Common';
import { Button } from '@/components/ui/button';

const CHECKS = {
  identity: 'Sabit demo kimliği', lease: 'Güncel bağlantı oturumu',
  clocks: 'Doğrulanmış saatler', baseline: 'Broker risk mutabakatı',
  permissions: 'MT5 izinleri', quote: 'Taze fiyat',
};

// This panel never grants execution authority: a successful GET is preparation only.
export default function DemoCommissioningPanel() {
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const load = async () => {
    if (busy) return;
    setBusy(true); setResult(null); setError('');
    try {
      const { data } = await api.get('/local-mt5/execution/commissioning');
      if (!data || typeof data !== 'object' || Array.isArray(data)
        || data.real_allowed !== false || data.execution_allowed !== false || typeof data.armed !== 'boolean'
        || typeof data.ready_for_controlled_test !== 'boolean'
        || !data.checks || typeof data.checks !== 'object' || Array.isArray(data.checks)
        || typeof data.stage !== 'string' || !Array.isArray(data.blockers)
        || !data.blockers.every(b => typeof b === 'string')) {
        throw new Error('DEMO_COMMISSIONING_RESPONSE_INVALID');
      }
      setResult(data);
    } catch (e) { setResult(null); setError(errMsg(e)); }
    finally { setBusy(false); }
  };
  const verified = result?.chain_verified === true;
  const prepared = result?.prerequisites_ready === true
    && result?.armed === false
    && Object.keys(CHECKS).every(key => result.checks[key] === true);
  return <Panel title="Kontrollü demo test hazırlığı" className="mb-4" right={<Tag>Salt okunur</Tag>}>
    <div className="space-y-3 text-sm">
      <p>Yalnız sabit MT5 demo hesabı. Bu kontrol emir göndermez, botu başlatmaz ve işlem izni vermez. Gerçek para kapalıdır. Kontrollü emir teslim yolu henüz bu panelden başlatılamaz.</p>
      <Button variant="outline" onClick={load} disabled={busy}>{busy ? 'Hazırlık okunuyor…' : 'Demo test hazırlığını kontrol et'}</Button>
      <p className="text-xs text-muted-foreground">Model çağrısı yapılmaz. Sonuç yalnız düğmeye bastığın anın ölçümüdür; sürekli işlem yetkisi değildir.</p>
      {error && <p role="alert" className="text-destructive">Demo hazırlık raporu alınamadı: {error}</p>}
      {result && <div className="space-y-3" role="status">
        <p>{prepared ? 'Veri ve hesap ön koşulları sağlandı; bu sonuç test teslim yolunun hazır olduğu anlamına gelmez.' : 'Kontrollü test hazırlığı tamamlanmadı.'}</p>
        <div className="flex flex-wrap gap-2">{Object.entries(CHECKS).map(([key, label]) =>
          <Tag key={key} tone={result.checks[key] === true ? 'up' : 'warn'}>{label}: {result.checks[key] === true ? 'doğrulandı' : 'eksik / bilinmiyor'}</Tag>)}</div>
        <p>Sunucu aşaması: {result.stage} · Demo emir yetkisi: {result.armed ? 'açık — bu panel değiştirmez' : 'kapalı'}</p>
        {result.blockers.length > 0 && <ul className="list-inside list-disc break-words">{result.blockers.map((blocker, i) => <li key={`${i}-${blocker}`}>{blocker}</li>)}</ul>}
        <p className="font-medium">Broker emir zinciri: {verified ? 'sunucu kayıtlarında doğrulandı' : 'henüz doğrulanmadı'}</p>
        <div className="flex flex-wrap gap-2">{['OPEN · korumalı açılış', 'MODIFY · stop güncelleme', 'CLOSE · kapanış'].map(label =>
          <Tag key={label} tone={verified ? 'up' : 'muted'}>{label}: {verified ? 'doğrulandı' : 'kanıt bekleniyor'}</Tag>)}</div>
        <p className="text-xs text-muted-foreground">Ön koşulların sağlanması başarılı broker testi değildir. Emir kabul yanıtı tek başına yeterli değildir; açılış, stop değişikliği ve kapanış gerçek broker kayıtlarıyla doğrulanmalıdır.</p>
      </div>}
    </div>
  </Panel>;
}
